import styled from 'styled-components';

export const StyledTOCSidebar = styled.div`
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
  left: ${props => (props.isOpened ? '0' : '-100vw')};
  overflow-y: auto;
  position: fixed;
  top: 40px;
  transition: 0.5s ease;
  width: 100vw;
  z-index: 2500;
  padding: 1.25em 1.5em;
`;

export const StyledTOCList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  > li {
    color: #0f4c81;
    cursor: pointer;

    &:hover {
      color: #177dd6;
    }
  }

  > li {
    margin-bottom: 1.25em;
  }

  > ul {
    padding-left: 1em;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: fit-content;

  > span {
    font-weight: 500;
    color: #4f4f4f;
  }

  > span:last-child {
    width: 32px;
  }
`;

export const StyledBookTitle = styled.p`
  margin: 0 0 0.75em;
  color: #1d1d1f;
`;

export const StyledBookAuthors = styled.p`
  margin: 0 0 1.5rem;
  color: #4f4f4f;
  font-size: 14.22px;
`;

export const StyledLine = styled.hr`
  width: 100%;
  border: 0.5px solid #c8c8c8;
  margin-bottom: 1.25em;
`;
